import React from 'react'
import App from './App'
import * as serviceWorker from './serviceWorker'
import './index.css'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { SuspenseRoot } from '@e3dc-react/shell/Elements/Suspense'
import { createRoot } from 'react-dom/client'
import './Configuration/i18n'

const router = createBrowserRouter([
  {
    id: 'root',
    path: '*',
    element: <App />,
  },
])

const container = document.getElementById('root')
const root = createRoot(container!)
root.render(<RouterProvider router={router} fallbackElement={<SuspenseRoot />} />)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
